export const START_LOADING = 'app/services/Trips/START_LOADING';
export const CLEAR_ERRORS = 'app/services/Trips/CLEAR_ERRORS';
export const QUERY_TRIPS_SUCCESS = 'app/services/Trips/QUERY_TRIPS_SUCCESS';
export const QUERY_TRIPS_FAIL = 'app/services/Trips/QUERY_TRIPS_FAIL';
export const GET_TRIP_SUCCESS = 'app/services/Trips/GET_TRIP_SUCCESS';
export const GET_TRIP_FAIL = 'app/services/Trips/GET_TRIP_FAIL';
export const DELETE_TRIP_SUCCESS = 'app/services/Trips/DELETE_TRIP_SUCCESS';
export const DELETE_TRIP_FAIL = 'app/services/Trips/DELETE_TRIP_FAIL';
export const CLEAR_TRIP = 'app/services/Trips/CLEAR_TRIP';

export const ADD_DAMAGE_SUCCESS = 'app/services/Trips/ADD_DAMAGE_SUCCESS';
export const ADD_DAMAGE_FAIL = 'app/services/Trips/ADD_DAMAGE_FAIL';
export const UPDATE_DAMAGE_SUCCESS = 'app/services/Trips/UPDATE_DAMAGE_SUCCESS';
export const UPDATE_DAMAGE_FAIL = 'app/services/Trips/ADD_DAMAGE_FAIL';
export const REMOVE_DAMAGE_SUCCESS = 'app/services/Trips/REMOVE_DAMAGE_SUCCESS';
export const REMOVE_DAMAGE_FAIL = 'app/services/Trips/REMOVE_DAMAGE_FAIL';

export const ADD_DAMAGE_PICTURE_SUCCESS = 'app/services/Trips/ADD_DAMAGE_PICTURE_SUCCESS';
export const ADD_DAMAGE_PICTURE_FAIL = 'app/services/Trips/ADD_DAMAGE_PICTURE_FAIL';
export const REMOVE_DAMAGE_PICTURE_SUCCESS = 'app/services/Trips/REMOVE_DAMAGE_PICTURE_SUCCESS';
export const REMOVE_DAMAGE_PICTURE_FAIL = 'app/services/Trips/REMOVE_DAMAGE_PICTURE_FAIL';

export const startLoading = () => ({
  type: START_LOADING,
});

export const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

export const receivedQueryTripsSuccess = (data, offset) => ({
  type: QUERY_TRIPS_SUCCESS,
  payload: {
    data,
    offset,
  },
});

export const receivedQueryTripsFail = (errors) => ({
  type: QUERY_TRIPS_FAIL,
  payload: { errors },
});

export const receivedTripSuccess = (data) => ({
  type: GET_TRIP_SUCCESS,
  payload: {
    data,
  },
});

export const receivedTripFail = (errors) => ({
  type: GET_TRIP_FAIL,
  payload: { errors },
});

export const receivedDeleteTripSuccess = () => ({
  type: DELETE_TRIP_SUCCESS,
});

export const receivedDeleteTripFail = (errors) => ({
  type: DELETE_TRIP_FAIL,
  payload: { errors },
});

export const clearTrip = () => ({
  type: CLEAR_TRIP,
});

export const receivedAddDamageSuccess = (damage) => ({
  type: ADD_DAMAGE_SUCCESS,
  payload: {
    damage,
  },
});

export const receivedAddDamageFail = (errors) => ({
  type: ADD_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedUpdateDamageSuccess = (damage) => ({
  type: UPDATE_DAMAGE_SUCCESS,
  payload: {
    damage,
  },
});

export const receivedUpdateDamageFail = (errors) => ({
  type: UPDATE_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedRemoveDamageSuccess = (damageId) => ({
  type: REMOVE_DAMAGE_SUCCESS,
  payload: {
    damageId,
  },
});

export const receivedRemoveDamageFail = (errors) => ({
  type: REMOVE_DAMAGE_FAIL,
  payload: { errors },
});

export const receivedAddDamagePictureSuccess = (damageId, pictures) => ({
  type: ADD_DAMAGE_PICTURE_SUCCESS,
  payload: {
    damageId,
    pictures,
  },
});

export const receivedAddDamagePictureFail = (errors) => ({
  type: ADD_DAMAGE_PICTURE_FAIL,
  payload: { errors },
});

export const receivedRemoveDamagePictureSuccess = (damageId, pictureId) => ({
  type: REMOVE_DAMAGE_PICTURE_SUCCESS,
  payload: {
    damageId,
    pictureId,
  },
});

export const receivedRemoveDamagePictureFail = (errors) => ({
  type: REMOVE_DAMAGE_PICTURE_FAIL,
  payload: { errors },
});
